import { KendoBaseComponent, KendoBaseDatasourceComponent } from '@progress/kendo-base-components-vue-wrapper'
import PivotGridProps from './PivotGridProps'

import Excel from './Excel'
import Messages from './Messages'
import Pdf from './Pdf'
import Sortable from '../Common/Sortable'

export default {
    props: PivotGridProps,
    emits: {
        'kendowidgetready': null
    },
    mixins: [
        KendoBaseComponent, 
        KendoBaseDatasourceComponent, 
        Excel, 
        Messages, 
        Pdf, 
        Sortable
    ],
    mounted() {
        kendo.jQuery(this.$el).kendoPivotGrid(this.widgetOptions)
        if(this.v3) {
            this.ready()
            this.$emit('kendowidgetready', this.kendoWidget())
        } else {
            this.$emit('kendowidgetready', this.kendoWidget())
        }
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoPivotGrid()
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-pivotgrid-vue-wrapper/src/KendoPivotGrid/KendoPivotGridMixin.js